import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
function HourForm({ hours, toogleEdit, saveUpdated }) {
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: hours
    });

    const onSubmit = (data) => {
        saveUpdated(data);
    };

    const submitOnEnter = (event) => {
        if (event.key !== 'Enter' || event.target?.closest('button')) {
            return;
        }
        event.preventDefault();
        handleSubmit(onSubmit)();
    };

    return (
        <tr onKeyDown={submitOnEnter}>
            <td>
                <input
                    type="text"
                    className={`form-control form-control-sm ${errors.day ? 'is-invalid' : ''}`}
                    {...register("day", { required: "Day is required" })}
                    disabled
                />
                {errors.day && <div className="invalid-feedback">{errors.day.message}</div>}
            </td>
            <td>
                <select
                    {...register("isOff")}
                    className={`form-select form-select-sm ${errors.isOff ? 'is-invalid' : ''}`}
                >
                    <option value="false">Working</option>
                    <option value="true">Off</option>
                </select>
                {errors.isOff && <div className="invalid-feedback">{errors.isOff.message}</div>}
            </td>
            <td>
                <input
                    type="time"
                    className={`form-control form-control-sm ${errors.startTime ? 'is-invalid' : ''}`}
                    {...register("startTime", {
                        required: hours.isOff === false ? "Start time is required" : false
                    })}
                />
                {errors.startTime && <div className="invalid-feedback">{errors.startTime.message}</div>}
            </td>
            <td>
                <input
                    type="time"
                    className={`form-control form-control-sm ${errors.endTime ? 'is-invalid' : ''}`}
                    {...register("endTime", {
                        required: hours.isOff === false ? "End time is required" : false
                    })}
                />
                {errors.endTime && <div className="invalid-feedback">{errors.endTime.message}</div>}
            </td>
            <td>
                <input
                    type="time"
                    className={`form-control form-control-sm ${errors.lunchFrom ? 'is-invalid' : ''}`}
                    {...register("lunchFrom")}
                />
                {errors.lunchFrom && <div className="invalid-feedback">{errors.lunchFrom.message}</div>}
            </td>
            <td>
                <input
                    type="time"
                    className={`form-control form-control-sm ${errors.lunchTo ? 'is-invalid' : ''}`}
                    {...register("lunchTo")}
                />
                {errors.lunchTo && <div className="invalid-feedback">{errors.lunchTo.message}</div>}
            </td>
            <td className="text-center">
                <div className="d-flex gap-2 justify-content-center">
                    <button
                        className="btn btn-success btn-sm"
                        type="button"
                        onClick={handleSubmit(onSubmit)}
                        title="Save changes"
                    >
                        <i className="bi bi-check-lg"></i>
                    </button>
                    <button
                        className="btn btn-secondary btn-sm"
                        type="button"
                        onClick={toogleEdit}
                        title="Cancel edit"
                    >
                        <i className="bi bi-x-lg"></i>
                    </button>
                </div>
            </td>
        </tr>
    );
}

export default function DayHours({ hours, handleUpdate }) {
    const [edit, setEdit] = useState(false);

    const toogleEdit = () => {
        setEdit(!edit);
    };

    const saveUpdated = (data) => {
        handleUpdate(data);
        toogleEdit();
    };

    const getStatusBadge = (isOff) => {
        return isOff === false ? (
            <span className="clinic-booking-status-badge clinic-booking-status-badge--active">
                <i className="bi bi-check-circle"></i>
                Working
            </span>
        ) : (
            <span className="clinic-booking-status-badge clinic-booking-status-badge--inactive">
                <i className="bi bi-x-circle"></i>
                Off
            </span>
        );
    };

    const formatTime = (time) => {
        if (!time) return '-';
        return time;
    };

    return (
        <>
            {edit ? (
                <HourForm
                    hours={hours}
                    toogleEdit={toogleEdit}
                    saveUpdated={saveUpdated}
                />
            ) : (
                <tr className="small">
                    <td className="clinic-booking-hours-day">
                        <i className="bi bi-calendar-day me-2 text-primary"></i>
                        {hours.day}
                    </td>
                    <td>{getStatusBadge(hours.isOff)}</td>
                    <td>
                        {hours.isOff === false ? (
                            <span className="clinic-booking-hours-time">
                                <i className="bi bi-clock"></i>
                                {formatTime(hours.startTime)}
                            </span>
                        ) : (
                            <span className="text-muted">—</span>
                        )}
                    </td>
                    <td>
                        {hours.isOff === false ? (
                            <span className="clinic-booking-hours-time">
                                <i className="bi bi-clock"></i>
                                {formatTime(hours.endTime)}
                            </span>
                        ) : (
                            <span className="text-muted">—</span>
                        )}
                    </td>
                    <td>
                        {hours.isOff === false && hours.lunchFrom ? (
                            <span className="clinic-booking-hours-time">
                                <i className="bi bi-egg-fried"></i>
                                {formatTime(hours.lunchFrom)}
                            </span>
                        ) : (
                            <span className="text-muted">—</span>
                        )}
                    </td>
                    <td>
                        {hours.isOff === false && hours.lunchTo ? (
                            <span className="clinic-booking-hours-time">
                                <i className="bi bi-egg-fried"></i>
                                {formatTime(hours.lunchTo)}
                            </span>
                        ) : (
                            <span className="text-muted">—</span>
                        )}
                    </td>
                    <td className="text-center">
                        <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={toogleEdit}
                            title="Edit schedule"
                        >
                            <i className="bi bi-pencil"></i>
                        </button>
                    </td>
                </tr>
            )}
        </>
    );
}